import { LanguageServerLogger } from "./lsp-logger-YYX06GHR.mjs";

//#region src/index.ts
function typeAssert(_value) {}

//#endregion
export { LanguageServerLogger, typeAssert };
//# sourceMappingURL=index.mjs.map